import { useCallback } from 'react'
import { useNotificationService } from 'src/features/notificationService/useNotificationService'
import { extractHttpErrorMessages } from 'src/state/middleware/saga/handleHttpError'
import { useMutationDeleteMultipleChoices } from '../api/useMutationDeleteMultipleChoices'

export const useDeleteMultipleChoices = () => {
  const { showNotification } = useNotificationService()
  const { mutate, isPending } = useMutationDeleteMultipleChoices()

  const deleteMultipleChoices = useCallback(
    (multipleChoiceId: number, onSuccess: () => void) => {
      mutate(multipleChoiceId, {
        onSuccess,
        onError: (e: unknown) => {
          showNotification('選択肢の削除に失敗しました', {
            notificationType: 'error',
            duration: 5,
            description: extractHttpErrorMessages(e),
          })
        },
      })
    },
    [mutate, showNotification],
  )

  return {
    deleteMultipleChoices,
    isPendingDeleteMultipleChoices: isPending,
  }
}
